import { render } from "./WebUpdate.vue?vue&type=template&id=fe1643e2"
import script from "./WebUpdate.vue?vue&type=script&lang=js"
export * from "./WebUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__